var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0}),React.createElement("path",{"className":"st0","d":"M236.6,1.9H20.2C9.9,1.9,1.5,10.1,1.5,20.2v217.3c0,10.1,8.4,18.3,18.7,18.3h216.4c10.4,0,18.8-8.2,18.8-18.3  V20.2C255.4,10.1,247,1.9,236.6,1.9z M76.8,218.3H39.1V97.1h37.7V218.3z M58,80.6c-12.1,0-21.8-9.8-21.8-21.8  c0-12,9.8-21.8,21.8-21.8c12,0,21.8,9.8,21.8,21.8C79.8,70.8,70,80.6,58,80.6z M217.9,218.3h-37.6v-58.9c0-14.1-0.3-32.1-19.6-32.1  c-19.6,0-22.6,15.3-22.6,31.1v60h-37.6V97.1h36.1v16.6h0.5c5-9.5,17.3-19.6,35.6-19.6c38.1,0,45.2,25.1,45.2,57.7V218.3z","key":1})]);
}

LinkedinInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 256.9 257.8","style":{"enableBackground":"new 0 0 256.9 257.8"},"xmlSpace":"preserve"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
